import {SelectionModel} from '@angular/cdk/collections';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {NotificationProvider} from '../../../models/notificationProvider';
import {Parent} from '../../../models/parent';
import {ParentUser} from '../../../models/ParentUser';
import {User} from '../../../models/user';
import {CommonService} from '../../../services/common.service';
import {ExcelService} from '../../../services/excel.service';
import {FileService} from '../../../services/file.service';
import {ParentService} from '../../../services/parent.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {GeneralEmailComponent} from '../../dialogs/general-email/general-email.component';
import {SearchDialogComponent} from '../../shared/search-dialog/search-dialog.component';
import {ParentInfoDialogComponent} from './parent-info-dialog/parent-info-dialog.component';
import {FormAssignmentComponent} from '../students-list/form-assignment/form-assignment.component';

@Component({
    selector: 'app-parents-list',
    templateUrl: './parents-list.component.html',
    styleUrls: ['./parents-list.component.scss']
})
export class ParentsListComponent implements OnInit {
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    columnsToDisplay: any[];
    currentPage: any;
    currentPageY = 0;
    currentQuery = '';
    currentSize = 10;
    filters = '';
    isLoading: boolean;
    notificationProviders: NotificationProvider[];
    originalQuery = '';
    pageTitle: any;
    parentInfo: User;
    parentSearchFields: any;
    parents: MatTableDataSource<Parent>;
    selection: SelectionModel<any>;
    query = '';
    resultsLength: number;
    searchValue = '';
    selectedRecords: number;
    showParentInfo: boolean;
    simpleSearchSelectedValue: any;
    skip: number;
    windowHeight: number;
    tableHeight: number;

    constructor(private commonService: CommonService,
                public dialog: MatDialog,
                public excelService: ExcelService,
                public fileService: FileService,
                public parentService: ParentService,
                public toastMessagesService: ToastMessagesService) {
        this.parents = new MatTableDataSource<Parent>();
        this.isLoading = true;
        this.columnsToDisplay = ['select', 'lastName', 'firstName', 'email', 'telephone', 'is_valid', 'actions'];
        this.selectedRecords = 5;
        this.skip = 0;
        this.resultsLength = 20;
        this.pageTitle = 'Επαφές';
        this.showParentInfo = false;
        this.selection = new SelectionModel<any>(true, []);
        this.parentSearchFields = new ParentUser().getSearchFields();
        this.windowHeight = window.innerHeight - 60;
        this.tableHeight = window.innerHeight - 400;
    }

    async ngOnInit() {
        this.showParentInfo = false;
        // await this.initParents();
        await this.initializeParents(null);
    }

    async initializeParents(filter?: any) {
        try {
            this.isLoading = true;
            this.parents = new MatTableDataSource<Parent>([]);
            this.parents = await this.initParents(filter);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
            this.parents.paginator = this.paginator;
            this.parents.sort = this.sort;
            this.commonService.setPaginatorTexts(this.paginator);
        }
    }

    async initParents(filter?: any) {
        try {
            return new MatTableDataSource<Parent>(await this.commonService.postRequest('parents', filter) as Parent[]);

            // this.commonService.postDataNoPromise('parents', filter).subscribe((data: any) => {
            //     this.parentService.parents = new MatTableDataSource<any>(data);
            //     this.parentService.parents.sort = this.sort;
            //     this.parentService.parents.paginator = this.paginator;
            // });
        } catch (e) {
            throw e;
        }
    }

    getQuery(filters?: any) {
        this.originalQuery = `people/parents`;
        this.query = this.originalQuery;

        if (filters || this.filters) {
            if (filters) {
                this.query += `&filter=${filters}`;
            }
            if (this.filters) {
                this.query += `&filter=${this.filters}`;
            }
        }

        const model = {
            skip: this.skip,
            first: this.selectedRecords,
            filter: filters ? filters : null
        };

        return {endpoint: 'people/parents', body: model};
        // return this.query;
    }

    // async initParents() {
    //     this.commonService.setPaginatorTexts(this.paginator);
    //     this.sort.sortChange.subscribe((sort) => {
    //         this.isLoading = true;
    //
    //         this.paginator.pageIndex = 0;
    //     });
    //
    //     this.paginator.page.subscribe((page) => {
    //         this.currentPage = page;
    //         this.skip = page.pageIndex * page.pageSize;
    //         this.selectedRecords = page.pageSize;
    //         this.isLoading = true;
    //     });
    //
    //
    //     merge(this.sort.sortChange, this.paginator.page)
    //         .pipe(
    //             startWith({}),
    //             switchMap(() => {
    //                 this.parents.data = [];
    //                 const query = this.getQuery();
    //                 return this.commonService.postDataNoPromise(query.endpoint, query.body);
    //                 // return this.commonService.getDataNoPromise(`people/parents?skip=${this.skip}&first=${this.selectedRecords}`);
    //             }),
    //             map((data: any) => {
    //                 this.resultsLength = data.count[0].count;
    //                 this.paginator.length = data.count[0].count;
    //                 this.isLoading = false;
    //                 return data.parents;
    //             }),
    //             catchError((e) => {
    //                 console.log(e);
    //                 this.isLoading = true;
    //
    //                 return observableOf([]);
    //             })
    //         ).subscribe((data) => {
    //         this.parents.data = data;
    //     });
    // }

    pageChanged($event: PageEvent) {
        console.log($event);
    }


    sendMessage(parent: any) {
        this.dialog.open(GeneralEmailComponent, {
            // height: '100vh',
            // panelClass: 'full-screen-modal',
            data: {
                mode: 4,
                emails: [parent.email]
            }
        });
    }

    sendEmail(parent: any) {
        this.dialog.open(GeneralEmailComponent, {
            // height: '100vh',
            // panelClass: 'full-screen-modal',
            data: {
                mode: 2,
                emails: [parent.email]
            }
        });
    }

    async getNotificationProviders() {
        try {
            const providersRequest = await this.commonService.getList(`common/notification_providers`);
            this.notificationProviders = providersRequest.object as NotificationProvider[];
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async getParentInfo(parent) {
        try {
            // const parentRequest = await this.commonService.getList(`people/parentInfo?userId=${parent.userId}`);
            // this.parentInfo = parentRequest.object[0] as User;
            // await this.getNotificationProviders();
            // this.showParentInfo = true;
            this.dialog.open(ParentInfoDialogComponent, {
                data: {
                    parent
                }
            });
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    close() {
        this.showParentInfo = false;
    }

    //#region checkboxes in table
    public isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;

        // @ts-ignore
        const numRows = this.parents.data.length;

        return numSelected === numRows;
    }

    public masterToggle(): void {
        // @ts-ignore
        this.isAllSelected() ? this.selection.clear() : this.parents.data.forEach((row) =>
            this.selection.select(row));
    }

    //#endregion

    showSearchDialog() {
        const searchQuery = this.dialog.open(SearchDialogComponent, {
            width: '1200px',
            height: '700px',
            data: {
                searchFields: this.parentSearchFields,
                section: 'parents'
            }
        });

        searchQuery.afterClosed().subscribe(async (query: string) => {
            if (query) {
                await this.initializeParents(query);
            } else {
                await this.initializeParents(null);
            }
        });
    }

    // showSearchDialog() {
    //     const searchQuery = this.dialog.open(SearchDialogComponent, {
    //         width: '1200px',
    //         height: '670px',
    //         data: {
    //             searchFields: this.parentSearchFields,
    //             section: 'parents',
    //         }
    //     });
    //
    //     searchQuery.afterClosed().subscribe(async (query: string) => {
    //         this.parents.data = [];
    //         this.isLoading = true;
    //         if (query) {
    //             this.currentQuery = query;
    //             try {
    //                 // tslint:disable-next-line:max-line-length
    //                 // const resultObject = await this.commonService.getList(`people/parents?filter=${query}&skip=${this.skip}&first=${this.selectedRecords}`);
    //                 const resultObject: any = await this.commonService.insertItem('people/parents', {
    //                     filter: query,
    //                     skip: this.skip,
    //                     first: this.selectedRecords
    //                 });
    //                 const parents = resultObject.object.parents;
    //                 this.resultsLength = parents.length;
    //                 this.parents.data = parents;
    //                 this.paginator.length = this.resultsLength;
    //             } catch (e) {
    //                 this.toastMessagesService.toastErrorMessage(e.message);
    //             } finally {
    //                 this.isLoading = false;
    //             }
    //         } else {
    //             this.currentQuery = '';
    //             try {
    //                 const resultObject: any = await this.commonService.insertItem('people/parents', {
    //                     filter: null,
    //                     skip: this.skip,
    //                     first: this.selectedRecords
    //                 });
    //                 // tslint:disable-next-line:max-line-length
    //                 // const resultObject = await this.commonService.getList(`people/parents?skip=${this.skip}&first=${this.selectedRecords}`);
    //                 const parents = resultObject.object.parents;
    //                 this.resultsLength = parents.length;
    //                 this.parents.data = parents;
    //                 this.paginator.length = resultObject.object.count[0].count;
    //             } catch (e) {
    //                 this.toastMessagesService.toastErrorMessage(e.message);
    //             } finally {
    //                 this.isLoading = false;
    //             }
    //         }
    //     });
    // }

    async fastSearch($event: any) {
        if ($event.keyCode === 13) {
            await this.search();
        }
    }

    async search() {
        if (!this.simpleSearchSelectedValue) {
            this.toastMessagesService.toastMessages('Παρακαλούμε συμπληρώστε κριτήριο αναζήτησης');
            return false;
        }
        this.parents.data = [];
        this.isLoading = true;
        if (this.searchValue) {
            const filter = `where ${this.simpleSearchSelectedValue.field} LIKE '%${this.searchValue}%'`;
            this.currentQuery = filter;
            await this.initializeParents(filter);
            // try {
            //     const resultObject: any = await this.commonService.insertItem('people/parents', {
            //         filter,
            //         skip: this.skip,
            //         first: this.selectedRecords
            //     });
            //     // tslint:disable-next-line:max-line-length
            //     // const resultObject = await this.commonService.getList(`people/parents?filter=${filter}&skip=${this.skip}&first=${this.selectedRecords}`);
            //     const parents = resultObject.object.parents;
            //     this.resultsLength = parents.length;
            //     this.parents.data = parents;
            //     this.paginator.length = this.resultsLength;
            //     this.isLoading = false;
            // } catch (e) {
            //     this.toastMessagesService.toastErrorMessage(e.message);
            // } finally {
            //     this.isLoading = false;
            // }
        } else {
            this.currentQuery = '';
            this.filters = this.simpleSearchSelectedValue.type === 'text' ? '' : this.filters;

            await this.initializeParents(this.filters);
            // try {
            //     const resultObject: any = await this.commonService.insertItem('people/parents', {
            //         skip: this.skip,
            //         first: this.selectedRecords
            //     });
            //     // const resultObject = await this.commonService.getList(`people/parents?skip=${this.skip}&first=${this.selectedRecords}`);
            //     const parents = resultObject.object.parents;
            //     console.log(resultObject);
            //     this.resultsLength = parents.length;
            //     this.parents.data = parents;
            //     this.paginator.length = resultObject.object.count[0].count;
            // } catch (e) {
            //     this.toastMessagesService.toastErrorMessage(e.message);
            // } finally {
            //     this.isLoading = false;
            // }
        }
    }

    async loadMore($event) {
        console.log($event);
        this.currentPageY = $event.pageY;
        try {
            this.parents.data = [];
            const resultObject: any = await this.commonService.insertItem('people/parents', {
                filter: this.currentQuery,
                skip: this.skip,
                first: this.selectedRecords
            });
            // const resultObject = await this.commonService.getList(`people/parents?filter=${this.currentQuery}&skip=0&first=${this.currentSize}`);
            const parents = resultObject.object.parents;
            console.log(resultObject);
            this.resultsLength = parents.length;
            this.parents.data = parents;
            this.paginator.length = resultObject.object.count[0].count;
            this.currentSize += 5;
            console.log(this.currentPageY);
            window.scroll(0, this.currentPageY);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
        }
    }

    displayParentInfo(parent) {
        const d = this.dialog.open(ParentInfoDialogComponent, {
            height: '100%',
            width: '100%',
            data: {
                parent
            },
            panelClass: 'full-screen-modal',
        });
    }

    exportToExcel() {

        const {parents, columns} = this.formatParentsModel();
        this.excelService.exportAsCustomExcelFile(parents, 'Επαφές', columns);
    }

    exportToPDF() {
        const {parents, columns} = this.formatParentsModel();
        const data = parents;
        this.fileService.onCustomSave('pdf/students', {data, columns}, 'Επαφές');
    }

    formatParentsModel() {
        const parents = [];
        for (const parent of this.parents.data) {
            const model = {
                lastName: parent.lastName,
                firstName: parent.firstName,
                email: parent.email,
                telephone: parent.telephone,
            };
            parents.push(model);
        }

        const columns = [{
            key: 'lastName',
            label: 'Επώνυμο',
        },
            {
                key: 'firstName',
                label: 'Όνομα',
            },
            {
                key: 'email',
                label: 'Email',
            },
            {
                key: 'telephone',
                label: 'Τηλέφωνο',
            }
         ];

        return {parents, columns};
    }

    initFormProc() {
        // Convert parents/users to student-like format for the wizard
        // Since we're sending directly to users (not through children),
        // we set the user as both father and mother to ensure they receive the notification
        const users = this.selection.selected.map(parent => {
            // Handle both 'id' and 'userId' field names from different data sources
            const parentId = parent.id || parent.userId;
            console.log('[initFormProc] Parent data:', parent, 'Using parentId:', parentId);
            return {
                id: parentId,           // This becomes child_id in the notification
                parentId: parentId,
                fatherId: parentId,     // camelCase for form-assignment component
                motherId: parentId,     // camelCase for form-assignment component
                firstName: parent.firstName,
                lastName: parent.lastName,
                email: parent.email,
                telephone: parent.telephone,
                fatherEmail: parent.email,
                motherEmail: parent.email
            };
        });

        this.dialog.open(FormAssignmentComponent, {
            width: '70%',
            height: '95%',
            panelClass: 'relative-dialog',
            disableClose: true,
            hasBackdrop: true,
            data: {
                students: users
            }
        });
    }
}
